<template>
    <div>
        <v-alert :value="requestFailed" type="error" outline class="mt-4">
            <span>{{requestErrorMessage}}</span>
        </v-alert>
        <v-card-title primary-title>
            <div>
                <div class="headline">Edit User Permissions</div>
            </div>
        </v-card-title>
        <v-card-text>
            <v-layout row>
                <v-flex xs12 md6>
                    <loading v-if="submitting" loadingMessage="Changing user permissions..."></loading>
                    <template v-else>
                        <user-permissions-form :initialValue="initialValue.permissions.roles"
                                               cancelButtonText="Cancel"
                                               @update="formUpdated"
                                               @submitted="formSubmitted"
                                               @cancelled="formCancelled"
                                               submitButtonText="Save Changes"></user-permissions-form>
                    </template>
                </v-flex>
            </v-layout>
        </v-card-text>
        <cancel-form-warning @abort="resetWaring" @confirm="cancel" :warnDialog="warnDialog"></cancel-form-warning>
    </div>
</template>

<script>
  import UserPermissionsForm from '@/forms/user/UserPermissionsForm'
  import CancelFormWarning from '@/views/app/elements/CancelFormWarning'
  import {CrudFormMixin} from '@/views/app/company/crud/crud-mixins'

  export default {
    name: 'UserChangePermissions',
    mixins: [CrudFormMixin],
    components: {
      UserPermissionsForm,
      CancelFormWarning
    },
    data: () => ({}),
    computed: {
      apiPath () {
        return `/admin/user/${this.existingData.uid}/permissions/roles`
      }
    },
    methods: {
      preparePayload (formData) {
        // As per RFC4627, sending single string values is not considered valid JSON. RFC7159 appears to relax this,
        // but for maximum compatibility we send it as an object.
        return {
          admin: formData.admin,
          entrant: formData.entrant,
          judge: formData.judge,
          member: formData.member,
          sysadmin: formData.sysadmin
        }
      }
    }
  }
</script>

<style scoped>

</style>